<template>
    <vx-card id="loader">
        <vs-table stripe :data="timeRangeStatuses" search max-items="10" pagination class="mt-5">
            <template slot="header">
                <div class="vx-row header-title ml-3">
                    <h3>Временные статусы</h3>
                    <vs-button class="mt-2" color="success" @click="createTimeRangeStatus()" type="filled">
                        Добавить
                    </vs-button>
                </div>
                
                <!-- <div class="vx-row mt-3 mb-2">
                    <div class="vx-col w-full">
                        <div class="mt-1">
                            <vs-input
                                v-model="searchPattern"
                                @input="onSearch"
                                autocomplete="off"
                                label="Поиск по названию"
                                placeholder="Введите название..."
                                class="mt-1 w-full"/>
                        </div>
                    </div>
                </div> -->
            </template>
            <template slot="thead">
                <vs-th class="vs-lg-6">
                    Название
                </vs-th>
                <vs-th class="vs-lg-4">
                    Включен
                </vs-th>
                <vs-th class="vs-lg-2">
                    Действия
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{tr.name}}</vs-td>
                    <vs-td>
                        <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="tr.active" @click.native="toggleStatus(tr)"></vs-checkbox>
                    </vs-td>
                    <vs-td>
                        <div class="inline-block">
                            <router-link :to="{ name: 'time-range-status-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать временной статус" position="top" delay=".3s">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7"/>
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <!-- <div class="inline-block cursor-pointer">
                            <vx-tooltip text="Удалить временной статус" position="top" delay=".3s">
                                <feather-icon @click="showDeleteModal(tr)" icon="XCircleIcon" class="inline-block mr-2 text-danger" svgClasses="w-7 h-7"/>
                            </vx-tooltip>
                        </div> -->
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <sweet-modal ref="deleteModal" icon="error" title="Удаление рубрики">
            <div class="mb-5">Вы действительно хотите удалить временной статус {{selected.name}}?</div>

            <vs-button class="" color="danger" @click="deleteTimeRangeStatus(selected)" type="filled">
                Удалить временной статус
            </vs-button>
        </sweet-modal>
    </vx-card>
</template>


<script>
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'

    export default {
        name: 'timeRangeStatuses',
        data() {
            return {
                timeRangeStatuses: [],
                selected: {},
                searchPattern: ''
            }
        },
        components: {
            SweetModal,
            SweetModalTab
        },
        methods: {
            loadTimeRangeStatuses() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    url: 'time-range-statuses',
                    method: 'GET',
                    // params: { searchPattern: this.searchPattern },
                    success: (timeRangeStatuses) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.timeRangeStatuses = timeRangeStatuses;
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка загрузки временных статусов.",
                            color: "danger",
                        });
                    },
                });
            },
            toggleStatus(timeRangeStatus) {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'PATCH',
                    url: 'time-range-statuses/' + timeRangeStatus.id + '/status',
                    params: { id: timeRangeStatus.id, active: !timeRangeStatus.active },
                    errors: this.errors,
                    success: () => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
         
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Временной статус успешно обновлен.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        if (err.request.status == 422 && err.data.errors['']) {
                            const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: "Внимание!",
                                text: error,
                                color: "danger",
                            });   
                        }

                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при обновлении временного статуса!",
                            color: "danger",
                        });
                    }
                })
            },
            createTimeRangeStatus() {
                this.$router.push('/time-range-statuses/create')
            },
            showDeleteModal(timeRangeStatus) {
                this.selected = timeRangeStatus;
                this.$refs.deleteModal.open();
            },
            deleteTimeRangeStatus(timeRangeStatus) {
                this.$axios({
                    method: 'DELETE',
                    url: 'time-range-statuses/' + timeRangeStatus.id,
                    errors: this.errors,
                    success: () => {
                        this.timeRangeStatuses = this.timeRangeStatuses.filter(c => c.id != timeRangeStatus.id);
                        this.$refs.deleteModal.close();
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно удалено",
                            text: "Временной статус успешно удален.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$refs.deleteModal.close();
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при удалении временнго статусв!",
                            color: "danger",
                        });
                    }
                })
            },
            onSearch() {
                this.loadTimeRangeStatuses();
            }
        },
        mounted() {
            this.loadTimeRangeStatuses();
        }
    }
</script>

<style lang="scss">
    table {
        tr.selected {
            cursor: text !important;
        }
    }
    thead {
        th {
            font-size: 15px !important;

            .sort-th {
                i {
                    font-size: 19px;
                }
            }
        }
    }
    .header-title {
        flex-direction: column;
    }
</style>